module.exports = __webpack_public_path__ + "static/media/chapul-large-cms.4cc1a442.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/chapul/chapul-large-cms.jpg
// module id = 667
// module chunks = 0